<script setup lang="ts">
const emits = defineEmits(['addRequested'])

const props = withDefaults(
  defineProps<{
    isAdded: boolean
    btnName: string
    btnStyle: string
    btnColor: string
    actionKey: string
  }>(),
  {
    isAdded: true,
    btnColor: '',
    actionKey: ''
  }
)
</script>
<template>
  <v-btn
    class="ma-2 exec-btn"
    :disabled="!props.isAdded"
    :color="props.btnColor"
    :style="{ backgroundColor: props.isAdded ? '' : props.btnStyle, }"
    @click="emits('addRequested', props.actionKey)"
  >
    {{ props.btnName }}
  </v-btn>
</template>